// codec base class
export default class CramCodec {
    constructor(parameters, dataType) {
        this.parameters = parameters;
        this.dataType = dataType;
    }
}
//# sourceMappingURL=_base.js.map